import { InjectionToken } from '@angular/core';

export const REGION_COOKIE_KEY = 'x_shop_region_id';
export const DEFAULT_REGION_ID = new InjectionToken<number | null>('DEFAULT_REGION');
